import { useContext } from 'react';
import { ExperimentProviderContext } from '|/helpers/experiment';
import useExperimentBucket from '|/hooks/use-experiment-bucket';

const useIsInBucket = (
  experimentId: string,
  bucketId: string,
  otherBuckets: string[] = []
) => {
  if (!experimentId) return null;
  const assignedBucket = useExperimentBucket(experimentId, [
    bucketId,
    ...otherBuckets
  ]);

  return assignedBucket === null ? null : bucketId === assignedBucket;
};

/**
 * Variant of useIsInBucket that also returns whether the bucketing request errored.
 * Use this when you need to handle API failures differently (e.g., fallback to treatment).
 */
export const useIsInBucketWithError = (
  experimentId: string,
  bucketId: string,
  otherBuckets: string[] = []
) => {
  const isInBucket = useIsInBucket(experimentId, bucketId, otherBuckets);
  const { experiments } = useContext(ExperimentProviderContext);
  const hasErrored = experiments[experimentId]?.hasErrored ?? false;

  return { isInBucket, hasErrored };
};

export default useIsInBucket;
